import { Download, Pencil, Printer, Trash2 } from "lucide-react";
var ICON_MAPPING = {
  "delete": Trash2,
  edit: Pencil,
  print: Printer,
  download: Download
};
export default ICON_MAPPING;